














































import { Component, Vue } from 'vue-property-decorator';
import {OnBoardingEditModel} from '@/services/api/nswag/stapiclient_generated';
import {stAccountApi} from '@/services/st-api';
import {TimeEntryStore} from '@/store/time-entry-store';
import {UserStore} from '@/store/user-module';

@Component({
  components: {
  },
})
export default class OnBoardingMigration extends Vue {
  showOnboarding = true;
  loading: boolean = false;

  onboardingModel: OnBoardingEditModel = OnBoardingEditModel.fromJS({});

  async mounted() {
  }

  async skipOnboarding() {
    try {
      this.loading = true;
      await stAccountApi.skipOnBoarding();
      await this.endOnboarding();
    } finally {
      this.loading = false;
    }
  }

  async endOnboarding() {
    this.showOnboarding = false;
    await UserStore.reloadStore();
    await this.$router.push({ name: 'TimeEntries' })
  }
}
